import script from "./EditAuthorizationDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./EditAuthorizationDialog.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem});
